import { clsx } from "clsx";

export default function IconDateTime({ className }: { className?: string }) {
  return (
    <svg
      className={clsx("", className)}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 3C5.59375 3 2 6.59375 2 11C2 13.9479 3.61458 16.5208 6 17.9063V27H28V7H23V6H21V7H16.9063C15.5208 4.61458 12.9479 3 10 3ZM10 5C13.3229 5 16 7.67708 16 11C16 14.3229 13.3229 17 10 17C6.67708 17 4 14.3229 4 11C4 7.67708 6.67708 5 10 5ZM9 7V11.5625L7.28125 13.2813L8.71875 14.7187L10.7187 12.7187L11 12.4063V7H9ZM17.7187 9H21V10H23V9H26V11H18C18 10.3073 17.8854 9.64583 17.7187 9ZM17.7187 13H26V25H8V18.7187C8.64583 18.8854 9.30729 19 10 19C13.7135 19 16.8229 16.4375 17.7187 13ZM18 17V19H20V17H18ZM22 17V19H24V17H22ZM10 21V23H12V21H10ZM14 21V23H16V21H14ZM18 21V23H20V21H18ZM22 21V23H24V21H22Z"
        fill="currentColor"
      />
    </svg>
  );
}
